import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

export function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="/logo-vitacode.png"
            alt="VitaCode"
            className="h-10 w-auto cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
        </div>

        {/* Navigation Links */}
        <div className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('sobre')}
            className="text-gray-700 hover:text-vitapink transition-colors font-medium"
          >
            Sobre
          </button>
          <button
            onClick={() => scrollToSection('contato')}
            className="text-gray-700 hover:text-vitapink transition-colors font-medium"
          >
            Contato
          </button>
          <Button
            onClick={() => window.open('https://wa.me/5567991768713', '_blank')}
            className="bg-vitapink hover:bg-vitapink-700 text-white"
          >
            Fale Conosco
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <Button
            onClick={() => window.open('https://wa.me/5567991768713', '_blank')}
            size="sm"
            className="bg-vitapink hover:bg-vitapink-700 text-white"
          >
            Contato
          </Button>
        </div>
      </div>
    </nav>
  );
}
